import React from 'react';
import { motion } from 'framer-motion';
import { Check, Sparkles, ShieldCheck } from 'lucide-react';
export function PricingSection() {
  const handleCheckoutClick = () => {
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout');
    }
    const checkoutUrl = 'https://pay.cakto.com.br/39bytf3_682112';
    const urlParams = window.location.search;
    window.location.href = checkoutUrl + urlParams;
  };
  return <section id="pricing" className="py-12 md:py-16 bg-gradient-to-b from-white to-stone-50" data-id="element-287">
      <div className="max-w-4xl mx-auto px-6" data-id="element-288">
        {/* Header Outside Card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-289">
          <div className="inline-flex items-center gap-2 bg-brand-50 text-brand-600 px-4 py-2 rounded-full text-sm font-bold mb-4 border border-brand-200" data-id="element-290">
            <Sparkles className="w-4 h-4" data-id="element-291" />
            OFERTA ESPECIAL
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-3" data-id="element-292">
            A Fórmula do Efeito Boutique™
          </h2>
          <p className="text-base md:text-lg text-stone-600 max-w-2xl mx-auto" data-id="element-293">
            Transforme a apresentação dos seus produtos e valorize-os
          </p>
        </motion.div>

        {/* Pricing Card */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative bg-white rounded-3xl shadow-2xl shadow-emerald-200 border-2 border-emerald-400 overflow-visible max-w-xl mx-auto mt-6" data-id="element-294">
          {/* Most Popular Tag */}
          <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10" data-id="element-295">
            <div className="bg-amber-400 text-stone-900 px-4 py-1 rounded-full text-xs font-bold uppercase tracking-wide shadow-md border border-amber-500" data-id="element-296">
              ⭐ Mais Pedido
            </div>
          </div>

          {/* Price Header with Green Background */}
          <div className="bg-gradient-to-br from-emerald-400 to-emerald-600 text-white text-center py-6 px-6 pt-8 rounded-t-3xl" data-id="element-297">
            <p className="text-sm mb-1 opacity-90" data-id="element-298">
              De <span className="line-through" data-id="element-299">R$ 97,00</span> por
            </p>
            <div className="flex items-center justify-center gap-2" data-id="element-300">
              <span className="text-5xl md:text-6xl font-bold tracking-tight" data-id="element-301">
                R$ 27
              </span>
            </div>
            <p className="text-sm mt-2 opacity-90" data-id="element-302">
              Investimento único • Acesso vitalício
            </p>
          </div>

          <div className="p-6 md:p-8" data-id="element-303">
            {/* What's Included */}
            <div className="space-y-3 mb-6" data-id="element-304">
              <h3 className="font-bold text-base text-stone-900 mb-3" data-id="element-305">
                O que você vai receber:
              </h3>

              <div className="space-y-2" data-id="element-306">
                <div className="flex items-start gap-2.5" data-id="element-307">
                  <div className="w-4 h-4 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-308">
                    <Check className="w-2.5 h-2.5 text-green-600" strokeWidth={3} data-id="element-309" />
                  </div>
                  <div data-id="element-310">
                    <p className="text-sm text-stone-900" data-id="element-311">
                      Módulo 1 — Pare de criar no improviso
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-2.5" data-id="element-312">
                  <div className="w-4 h-4 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-313">
                    <Check className="w-2.5 h-2.5 text-green-600" strokeWidth={3} data-id="element-314" />
                  </div>
                  <div data-id="element-315">
                    <p className="text-sm text-stone-900" data-id="element-316">
                      Módulo 2 — Escolha o que valoriza
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-2.5" data-id="element-317">
                  <div className="w-4 h-4 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-318">
                    <Check className="w-2.5 h-2.5 text-green-600" strokeWidth={3} data-id="element-319" />
                  </div>
                  <div data-id="element-320">
                    <p className="text-sm text-stone-900" data-id="element-321">
                      Módulo 3 — A fórmula visual
                    </p>
                  </div>
                </div>

                {/* Bonus Section */}
                <div className="pt-3 mt-3 border-t border-stone-100" data-id="element-322">
                  <p className="text-xs font-bold text-brand-600 mb-2 uppercase tracking-wide" data-id="element-323">
                    + Bônus Exclusivos:
                  </p>

                  <div className="flex items-start gap-2.5 mb-1.5" data-id="element-324">
                    <div className="w-4 h-4 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-325">
                      <Check className="w-2.5 h-2.5 text-green-600" strokeWidth={3} data-id="element-326" />
                    </div>
                    <div data-id="element-327">
                      <p className="text-sm font-semibold text-stone-900" data-id="element-328">
                        40 ideias aplicáveis
                      </p>
                      <p className="text-xs text-stone-600" data-id="element-329">
                        Produtos validados com o método
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-2.5" data-id="element-330">
                    <div className="w-4 h-4 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-331">
                      <Check className="w-2.5 h-2.5 text-green-600" strokeWidth={3} data-id="element-332" />
                    </div>
                    <div data-id="element-333">
                      <p className="text-sm font-semibold text-stone-900" data-id="element-334">
                        Listas de materiais e custos
                      </p>
                      <p className="text-xs text-stone-600" data-id="element-335">
                        Planejamento prático e econômico
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <button onClick={handleCheckoutClick} className="w-full bg-pink-500 hover:bg-pink-600 text-white font-bold text-base md:text-lg px-8 py-4 rounded-xl shadow-lg shadow-pink-200 hover:shadow-pink-300 transition-all duration-300" data-id="element-336">
              👉 Quero faturar mais com os meus produtos
            </button>

            {/* Guarantee Seal */}
            <div className="flex items-center justify-center gap-2 mt-4 pt-4 border-t border-stone-100" data-id="element-337">
              <ShieldCheck className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-338" />
              <p className="text-sm text-stone-500 font-medium" data-id="element-339">
                Se você não ficar satisfeita, devolvemos 100% do seu dinheiro
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}